import { InlineStack, Select, Spinner, Text } from '@shopify/polaris';

/**
 * Location and printer selects for label printing.
 *
 * The location select is shown for both print methods, because it also decides which
 * Market catalog price prints on the label. `showPrinter` hides the printer select on the
 * PDF path, where there is no printer to pick.
 */
export function ZebraPrinterPicker({
    isLoading,
    locationOptions,
    printerOptions,
    selectedLocationGid,
    onLocationChange,
    selectedPrinterDeviceId,
    onPrinterChange,
    printerDisabled,
    printerHelpText,
    showPrinter = true,
    showLocation = true,
    locationHelpText,
}) {
    if (isLoading) {
        return (
            <InlineStack align="start" gap="200" blockAlign="center">
                <Spinner accessibilityLabel="Loading locations" size="small" />
                <Text as="span" variant="bodySm">
                    Loading locations and printers...
                </Text>
            </InlineStack>
        );
    }

    return (
        <>
            {showLocation && <Select label="Location" options={locationOptions} value={selectedLocationGid || ''} onChange={(value) => onLocationChange(String(value))} helpText={locationHelpText} />}

            {showPrinter && (
                <Select
                    label="Printer"
                    options={printerOptions}
                    value={selectedPrinterDeviceId || ''}
                    onChange={(value) => onPrinterChange(String(value))}
                    disabled={printerDisabled}
                    helpText={printerHelpText}
                />
            )}
        </>
    );
}
